/**
 * PreferenceCardHeader
 *
 * Reusable flattened header component for preference cards.
 * Reduces repeated HStack > Box > Icon + Text pattern to a single component.
 */
import { HStack, Text } from '@chakra-ui/react'
import type { LucideIcon } from 'lucide-react'

interface PreferenceCardHeaderProps {
  icon: LucideIcon
  label: string
  color: string
}

/**
 * Flattened header for preference cards.
 * Uses icon color directly instead of wrapping in Box.
 */
export function PreferenceCardHeader({ icon: Icon, label, color }: PreferenceCardHeaderProps) {
  return (
    <HStack spacing={2}>
      <Icon size={16} color={`var(--chakra-colors-${color.replace('.', '-')})`} />
      <Text fontSize="sm" color="var(--card-text-2)">
        {label}
      </Text>
    </HStack>
  )
}
